export function setStockInURL(stock){
    window.history.pushState({}, null, window.location.origin+window.location.pathname+"?ticker="+stock.nasdaq);
}